import React from "react";

interface GenreListProps {
    genreCounts: ({genre: string, count: number})[];
}

const GenreList: React.FC<GenreListProps> = ({ genreCounts }) => {
    const totalCount = genreCounts.map(a => a.count).reduce((a, b) => a + b);
    return (
        <div className="column-centered">
            <div className="flex flex-col">
                { 
                    genreCounts.map(({genre, count}) => (
                        <div key={genre} className="row align-center space-x-2 my-2">
                            <p className="text-xl text-center">{genre}:</p>
                            <p className="">{` ${count} / ${totalCount}`}</p>
                            <p className="">{` ( ${Math.floor((count/totalCount) * 100) / 100} % )`}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default GenreList;
